"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanPersistentState = exports.persistStoreState = exports.getInitialState = void 0;
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var container_1 = __importDefault(require("../container"));
var Persistence_1 = __importDefault(require("./services/Persistence"));
var prevPersistState = null;
function getInitialState() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, Persistence_1.default.loadPersistedState()];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.getInitialState = getInitialState;
function persistStoreState(getState) {
    return __awaiter(this, void 0, void 0, function () {
        var settings, persist, logger, state, stateToPersist, diff;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    settings = container_1.default.get("SETTINGS");
                    persist = container_1.default.get("PERSISTENCE");
                    logger = container_1.default.get("LOGGING").getLogger("@redux/persist");
                    state = getState();
                    stateToPersist = Persistence_1.default.getStateToPersist(state);
                    if (!!(0, lodash_isequal_1.default)(stateToPersist, prevPersistState)) return [3, 2];
                    if (settings.getSetting("PERSISTENCE_LOGGING", false)) {
                        diff = prevPersistState
                            ? prevPersistState && keyChanges(stateToPersist, prevPersistState)
                            : null;
                        logger.debug("Persisting state", { diff: diff });
                    }
                    prevPersistState = stateToPersist;
                    return [4, persist.persistState(stateToPersist)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    });
}
exports.persistStoreState = persistStoreState;
function cleanPersistentState() {
    return __awaiter(this, void 0, void 0, function () {
        var persist;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    persist = container_1.default.get("PERSISTENCE");
                    return [4, persist.clearState()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.cleanPersistentState = cleanPersistentState;
function keyChanges(base, object) {
    var changes = {};
    function walkObject(base, object, path) {
        var e_1, _a, e_2, _b;
        if (path === void 0) { path = ""; }
        try {
            for (var _c = __values(Object.keys(base)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                var currentPath = path === "" ? key : "".concat(path, ".").concat(key);
                if (object[key] === undefined) {
                    changes[currentPath] = "-";
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _e = __values(Object.entries(object)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var _g = __read(_f.value, 2), key = _g[0], value = _g[1];
                var currentPath = Array.isArray(object)
                    ? path + "[".concat(key, "]")
                    : path === ""
                        ? key
                        : "".concat(path, ".").concat(key);
                if (base[key] === undefined) {
                    changes[currentPath] = "+";
                }
                else if (value !== base[key]) {
                    if (typeof value === "object" && typeof base[key] === "object") {
                        walkObject(base[key], value, currentPath);
                    }
                    else {
                        changes[currentPath] = object[key];
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    walkObject(base, object);
    return changes;
}
//# sourceMappingURL=persist.js.map